import { CETokenAttributesBase } from './ce-token-attributes-base'


export class CETokenAttributes extends CETokenAttributesBase {

}